import { Box, Container, Skeleton, Stack } from "@mui/material";
import Grid from "@mui/material/Grid";

export const LoadingSkeleton = () => (
  <Container maxWidth="lg" sx={{ py: 10, minHeight: "100vh" }}>
    <Grid sx={{ mb: 10 }}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Skeleton variant="rounded" width={44} height={44} sx={{ borderRadius: 1, mr: 1 }} />
        <Skeleton variant="text" width={340} height={48} />
      </Box>
    </Grid>

    <Stack spacing={10} sx={{ mb: 5 }}>
      <Skeleton variant="text" width="60%" height={32} />
    </Stack>

    <Box sx={{ maxWidth: { xs: 625, xxl: 800, uhd: 1000 }, mx: "auto", mb: 5 }}>
      <Stack direction="row" spacing={2} justifyContent="space-between">
        <Skeleton variant="rounded" height={32} width="30%" />
        <Skeleton variant="rounded" height={32} width="30%" />
        <Skeleton variant="rounded" height={32} width="30%" />
      </Stack>
    </Box>

    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 4 }}>
        <Skeleton variant="rounded" height={108} sx={{ borderRadius: 2 }} />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <Skeleton variant="rounded" height={108} sx={{ borderRadius: 2 }} />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <Skeleton variant="rounded" height={108} sx={{ borderRadius: 2 }} />
      </Grid>
    </Grid>

    <Stack direction="row" justifyContent="flex-end" spacing={1} sx={{ mt: 3 }}>
      <Skeleton variant="rounded" width={120} height={36} />
    </Stack>
  </Container>
);
